import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTIONS_GET_CLAIM_BY_ID } from "../../action-types/actions";

export const getClaimById = createAsyncThunk(
  ACTIONS_GET_CLAIM_BY_ID.getClaimById,
  async (claimId, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.claims.replace(
          "{claimId}",
          claimId,
        )}`,
      );

      if (response?.data?.status === true || response?.status === 200) {
        return response.data;
      } else {
        toast.error(response?.data?.message || "Failed to fetch claim details");
        return rejectWithValue(response.data);
      }
    } catch (error) {
      console.error("Error fetching claim details:", error);
      const errMsg =
        error?.response?.data?.message ||
        "Something went wrong while fetching claim details";
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  },
);
